// Emphasize matched text with a span element
export function emphasizeMatchedText(text, searchTerm) {
  if (searchTerm) {
    // Escape special characters in the search term
    let escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    let searchRegex = new RegExp(escapedSearchTerm, 'gi')

    // Split the text into text nodes and HTML tags
    let parts = text.split(/(<[^>]*>)/g)
    for (let i = 0; i < parts.length; i++) {
      // Only apply highlighting to text nodes (not HTML tags)
      if (parts[i][0] !== '<') {
        parts[i] = parts[i].replace(searchRegex, function (match) {
          return '<span class="is-matched">' + match + '</span>'
        })
      }
    }

    // Reassemble the string
    return parts.join('')
  }
  return text
}
